import styles from './Footer.module.css';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router';
import NavMetaPages from './NavMetaPages.jsx';

function Footer({}) {
  return (
    <div className={styles.Footer}>
      <Container>
        <Row>
          <Col sm={6} md={3}>
            <ul>
              <li>
                <Link to={'/rivers/ross'}>Ross River</Link>
              </li>
              <li>
                <Link to={'/rivers/bohle'}>Bohle River</Link>
              </li>
              <li>
                <Link to={'/rivers/black'}>Black River</Link>
              </li>
              <li>
                <Link to={'/rivers/alligator'}>Alligator Creek</Link>
              </li>
            </ul>
          </Col>
          <Col sm={6} md={3}>
            <NavMetaPages />
          </Col>
          <Col sm={12} md={6}>
            <p className="fw-bold">
              &copy; 2025 Townsville.Today&nbsp;|&nbsp;
              <span className="text-muted">Built, Maintained and Hosted by <a href={"https://noctra.com.au"}>Noctra Consulting</a>.</span>
            </p>
            <p>
              Data on this site is sourced from the{' '}
              <a href={'http://www.bom.gov.au/data-access/3rd-party-attribution.shtml'}>Bureau of Meteorology</a>, the{' '}
              <a href={'https://www.qld.gov.au/'}>Queensland Government</a> and{' '}
              <Link to={'/legal/data#data-sources'}>other sources</Link>. Townsville.Today is not affiliated with any
              government agency.
            </p>

            <p>
              The information presented by this site includes data which has not been quality controlled or validated.
              It should be used for informational purposes only and is not a substitute for official sources of
              information. <Link to={'/legal/data'}>Learn more...</Link>
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Footer
